import { lazy, Suspense } from 'react';

import { ErrorBoundaryWithRetry } from '@/_components';

import Loading from './loading';

const Page = lazy(() => import('./page'));

export default function NewModal() {
  return (
    <ErrorBoundaryWithRetry>
      <Suspense fallback={<Loading isModal />}>
        <Page isModal />
      </Suspense>
    </ErrorBoundaryWithRetry>
  );
}
